module.exports = __webpack_public_path__ + "img/logo.1510c50a.png";